import { ActionCreator, applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { monitorWsReducer, MONITOR_ENDPOINT, wsActionsMonitor } from './monitorWsReducer';
import thunk, { ThunkAction } from 'redux-thunk';
import { socketMiddleware } from '../middlewares/wsMiddleware';
import { TMonitorWsActions } from '../actions/monitorWsActions';
import { settingsReducer } from './settingsSetReducer';

export const rootReducer = combineReducers({
    monitor: monitorWsReducer,
    settings: settingsReducer,
});

declare global {
    interface Window {
      __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const wsMonitor = socketMiddleware(MONITOR_ENDPOINT, wsActionsMonitor);

const middleWares = applyMiddleware(thunk, wsMonitor);
const enhancer = composeEnhancers(middleWares);

export const store = createStore(rootReducer, enhancer);

export type TStore = ReturnType<typeof rootReducer>;

type TApplicationActions = 
    TMonitorWsActions;

export type AppThunk<TReturn = void> = ActionCreator<ThunkAction<TReturn, TStore, unknown, TApplicationActions> >;

export type AppDispatch = typeof store.dispatch;